<h2>Create a new Configuration</h2>
<form [formGroup]="newConfigForm" class="col w100 gap-48">
    <div class="sunkenarea w100">
        <h3>Main Data</h3>
        <rr-input
            label="Configurationname"
            placeholder="Give the Configuration a typical name"
            [required]="true"
            formControlName="name"
        ></rr-input>
        <rr-textarea
            [required]="true"
            label="Description"
            formControlName="description"
            placeholder="Provide a detailed description. Which is provided as info popover in the frontend."
        ></rr-textarea>
        <rr-textarea
            [required]="true"
            label="Step Goal"
            formControlName="stepGoal"
            placeholder="Step Goal - youn know what to do :-)"
        ></rr-textarea>
    </div>

    <div class="sunkenarea">
        <h3>Key Questions *</h3>
        <div class="w100">
            Create at minimum one Key Question which will be answered late in
            the Step by AI and the user.
        </div>
        <div
            class="col gap-4 questionwrapper"
            formArrayName="keyQuestions"
            *ngIf="keyQuestions?.controls?.length! > 0"
        >
            <div
                class="w100 card row space-between align-center gap-16"
                *ngFor="
                    let questionCtrl of keyQuestions.controls;
                    let i = index
                "
                [formGroupName]="i"
            >
                <div class="col">
                    <rr-icon
                        name="chevron-up"
                        class="w20 pointer"
                        (click)="changeQuestionOrder(i, i - 1)"
                        *ngIf="i !== 0"
                    ></rr-icon>
                    <rr-icon
                        name="chevron-down"
                        class="w20 pointer"
                        (click)="changeQuestionOrder(i, i + 1)"
                        *ngIf="i + 1 !== keyQuestions.controls.length"
                    ></rr-icon>
                </div>
                <div
                    *ngIf="i !== editKeyQuestion"
                    class="row gap-16 space-between w100 align-center"
                >
                    <div class="w100 col grow-1" *ngIf="i !== editKeyQuestion">
                        <span class="strong">{{
                            questionCtrl.get("title")?.value
                        }}</span>
                        <span class="">{{
                            questionCtrl.get("question")?.value
                        }}</span>
                        <span class="tiny">{{
                            questionCtrl.get("description")?.value
                        }}</span>
                    </div>
                    <rr-icon
                        *ngIf="i !== editKeyQuestion"
                        class="roundicon w24 pointer"
                        name="edit"
                        (click)="toggleKeyQuestionEdit(i)"
                    ></rr-icon>
                    <rr-icon
                        *ngIf="i !== editKeyQuestion"
                        class="roundicon w24 pointer"
                        name="trash"
                        (click)="removeKeyQuestion(i)"
                    ></rr-icon>
                </div>
                <div
                    *ngIf="i === editKeyQuestion"
                    class="row gap-16 space-between w100 align-center"
                >
                    <div class="card w100 col grow-1">
                        <rr-input
                            placeholder="Title for Key-Question"
                            [FormControl]="editKeyQuestionTitle"
                        ></rr-input>
                        <rr-input
                            placeholder="The question"
                            [FormControl]="editKeyQuestionQ"
                        ></rr-input>
                        <rr-textarea
                            placeholder="Provide additional details"
                            (change)="onKeyQuestionDetailsChange($event)"
                            [value]="questionCtrl.value.description"
                        ></rr-textarea>
                    </div>
                    <rr-icon
                        class="roundicon w24 pointer"
                        name="save"
                        (click)="saveKeyQuestionEdit(i)"
                    ></rr-icon>
                    <rr-icon
                        class="roundicon w24 pointer"
                        name="close"
                        (click)="toggleKeyQuestionEdit(i)"
                    ></rr-icon>
                </div>
            </div>
        </div>
        <div class="col questionadder w100">
            <div class="strong">Add a Key Question:</div>
            <div class="col gap-8 w100">
                <rr-input
                    placeholder="Title for Key-Question"
                    #newQuestionTitle
                ></rr-input>
                <rr-input placeholder="The question" #newQuestion></rr-input>
                <rr-textarea
                    placeholder="Provide additional details"
                    #newDetails
                ></rr-textarea>
                <div class="row w100 align-center justify-end gap-24">
                    <rr-btn
                        size="Small"
                        type="Link"
                        (click)="
                            newQuestionTitle.FormControl.setValue('');
                            newQuestion.FormControl.setValue('');
                            newDetails.FormControl.setValue('')
                        "
                        >Reset add Question-Form</rr-btn
                    >
                    <rr-btn
                        size="Small"
                        type="Secondary"
                        iconStart="add"
                        (click)="
                            addKeyQuestion(
                                newQuestion.FormControl.value,
                                newDetails.FormControl.value,
                                newQuestionTitle.FormControl.value
                            )
                        "
                        >Add Key Question</rr-btn
                    >
                </div>
            </div>
        </div>
    </div>

    <div class="sunkenarea">
        <h3>Agent Data</h3>
        <rr-select
            label="Agent for the Configuration"
            [required]="true"
            [options]="agentList"
            optionName="name"
            optionValue="id"
            formControlName="agentId"
        ></rr-select>
        <rr-textarea
            label="Extended Agent Prompt"
            formControlName="agentPrompt"
            placeholder="Provide an extended agent prompt, to make a difference between other configurations."
        ></rr-textarea>
    </div>
    <div class="sunkenarea">
        <h3>Specials</h3>
        <div class="row gap-8 w100">
            <rr-checkbox formControlName="websearchStatus"
                >Allow Web Search?</rr-checkbox
            >
            <rr-checkbox formControlName="uploadStatus"
                >Allow File Upload?</rr-checkbox
            >
        </div>
        <div class="row gap-8 w100">
            <rr-input
                label="Credits"
                formControlName="credits"
                type="number"
                hint="Will be automatically generated, or set manually."
            ></rr-input>

            <rr-input
                label="Duration in Minutes"
                formControlName="duration"
                type="number"
                hint="Will be automatically generated, or set manually."
            ></rr-input>
        </div>
    </div>
    <div class="sunkenarea">
        <h3>Closing</h3>
        <rr-select
            label="Closing Asset"
            formControlName="closingPromptId"
            [options]="closingStreamTypes"
            optionName="name"
            optionValue="id"
        ></rr-select>
    </div>
</form>
<div class="row gap-8 justify-end footer">
    <rr-btn type="Secondary" size="Medium" (click)="close()">Cancel</rr-btn>
    <rr-btn
        type="Primary"
        size="Medium"
        (click)="this.newConfigForm.valid ? save() : null"
        [disabled]="!this.newConfigForm.valid"
        >Save & Use Configuration</rr-btn
    >
</div>
<rr-spinner *ngIf="isLoading"></rr-spinner>
